import { getCurrentAppByHostname } from '../Helpers';
import { ReportValue } from '../Models/ReportValue';

export const setDraftReport = (report: ReportValue): void => {
  localStorage.setItem(
    `Smartforce.${
      getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
    }.DraftReport`,
    JSON.stringify(report)
  );
};

export const getDraftReport = (): ReportValue | null => {
  const draft = localStorage.getItem(
    `Smartforce.${
      getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
    }.DraftReport`
  );
  return draft ? (JSON.parse(draft) as ReportValue) : null;
};

export const clearDraftReport = (): void => {
  localStorage.removeItem(
    `Smartforce.${
      getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
    }.DraftReport`
  );
};

export const hasDraftReport = (): boolean => {
  const draft = localStorage.getItem(
    `Smartforce.${
      getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
    }.DraftReport`
  );
  return draft ? true : false;
};
